import { projectId } from './../firebase';
const functionsBaseUrl =
  'https://us-central1-' + projectId + '.cloudfunctions.net';
const hookFunctionName = 'classifyText';
const getTaskUrl = `${functionsBaseUrl}/${hookFunctionName}/getTask`;
const setAnswerUrl = `${functionsBaseUrl}/${hookFunctionName}/setAnswer`;
export { getTaskUrl, setAnswerUrl };
